import { useEffect, useState } from 'react';

export const useTick = (isActive) => {
	const [tick, setTick] = useState(0);

	useEffect(() => {
		if (!isActive) return;
		let raf;
		const onRaf = (time) => {
			setTick(time);
			raf = requestAnimationFrame(onRaf);
		};
		onRaf(0);
		return () => cancelAnimationFrame(raf);
	}, [setTick, isActive]);

	return tick;
};

export default useTick;
